import * as angular from 'angular';

import { ComponentDefinition } from '../../models';
import { BindingIssuesModalConfig } from './bindingIssuesModalConfig';

class BindingIssuesModalController implements angular.IComponentController {

    readonly modalConfig: BindingIssuesModalConfig;
    readonly modalSeriesMapConfirm: () => void;
    static $inject = [];
}

export const wtBindingIssuesModal: ComponentDefinition = {
    componentId: 'wtBindingIssuesModal',
    controller: BindingIssuesModalController,
    template: require('./bindingIssuesModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        modalConfig: '<',
        modalSeriesMapConfirm: '&',
    }
};
